import React from 'react';

// =====================================================================
// Paginação padrão das tabelas do portal (50 em 50).
//
// Client-side: as listas já vêm inteiras do servidor; aqui só se fatia. Some
// quando tudo cabe numa página.
//
// ⚠️ NASCEU EM `components/compras/Paginacao.js` e subiu para cá em 2026-08-24,
//    quando o módulo Chamados precisou dela. Duplicar seria a TERCEIRA paginação
//    do portal (o Financeiro tem a sua, `trocoPaginacao.js`, com API diferente) —
//    e o projeto trata duplicação como dívida, não como conveniência.
//    O Compras segue importando daqui, sem mudança de comportamento.
//
// ⚠️ A COR É PARÂMETRO porque cada módulo tem a sua identidade (ver
//    docs/ARQUITETURA.md › Paleta dos módulos). O padrão é o âmbar do Compras,
//    que era a cor cravada aqui antes — assim a promoção não mexe na aparência
//    de quem já usava.
// =====================================================================

export const POR_PAGINA = 50;

const btn = (habilitado, cor, fundo) => ({
  padding: '6px 14px', background: habilitado ? fundo : '#f8fafc',
  color: habilitado ? cor : '#cbd5e1', border: 'none', borderRadius: 6,
  fontWeight: 700, fontSize: 13, cursor: habilitado ? 'pointer' : 'default',
});

const Paginacao = ({ total, pagina, onMudar, cor = '#d97706', fundo = '#fffbeb' }) => {
  const paginas = Math.max(1, Math.ceil(total / POR_PAGINA));
  const inicio = total === 0 ? 0 : (pagina - 1) * POR_PAGINA + 1;
  const fim = Math.min(pagina * POR_PAGINA, total);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 10, flexWrap: 'wrap' }}>
      <span style={{ fontSize: 13, color: '#64748b' }}>
        Mostrando {inicio}–{fim} de {total} registro(s).
      </span>
      {paginas > 1 && (
        <>
          <button style={btn(pagina > 1, cor, fundo)} disabled={pagina <= 1} onClick={() => onMudar(pagina - 1)}>‹ Anterior</button>
          <span style={{ fontSize: 13, fontWeight: 700, color: '#334155' }}>Página {pagina} de {paginas}</span>
          <button style={btn(pagina < paginas, cor, fundo)} disabled={pagina >= paginas} onClick={() => onMudar(pagina + 1)}>Próxima ›</button>
        </>
      )}
    </div>
  );
};

export default Paginacao;
